
import React, { useState, useEffect } from 'react';
import InteractiveBentoGallery from "@/components/ui/interactive-bento-gallery";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import UserPortfolioModal from './UserPortfolioModal';
import { supabase } from '@/integrations/supabase/client';

export interface ProfilePortfolioProps {
  userId: string;
  isOwnProfile: boolean;
  mediaItems: any[];
  title: string;
}

export function ProfilePortfolio({
  userId,
  isOwnProfile,
  mediaItems,
  title
}: ProfilePortfolioProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Portfólio</h2>
        {isOwnProfile && (
          <Button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2">
            <PlusCircle className="h-4 w-4" />
            <span>Gerenciar Portfólio</span>
          </Button>
        )}
      </div>

      {mediaItems && mediaItems.length > 0 ? (
        <InteractiveBentoGallery
          mediaItems={mediaItems}
          title={title}
          description="Arraste para explorar o portfólio de trabalhos"
        />
      ) : (
        <div className="flex flex-col items-center justify-center py-16 bg-muted/30 rounded-lg">
          <p className="text-muted-foreground mb-4">
            {isOwnProfile
              ? "Você ainda não adicionou trabalhos ao seu portfólio"
              : "Este usuário não tem trabalhos em seu portfólio"}
          </p>
          {isOwnProfile && (
            <Button onClick={() => setIsModalOpen(true)}>
              <PlusCircle className="h-4 w-4 mr-2" />
              Adicionar Trabalho
            </Button>
          )}
        </div>
      )}

      {isModalOpen && (
        <UserPortfolioModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          userId={userId}
          canEdit={isOwnProfile}
        />
      )}
    </div>
  );
}
